/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { ListComponent } from './list';
export * from './list-adapter';
export * from './list-constants';
export * from './list-core';
export * from './list';
export function defineListComponent() {
    defineCustomElement(ListComponent);
}
